import { BaseFilter, ComparisonFilter } from './baseFilters.js';
export class FilterExists extends BaseFilter {
    constructor(name) {
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
    }
    getName() {
        return this.name;
    }
    toJson() {
        return { name: this.name };
    }
}
export class FilterLessThan extends ComparisonFilter {
    constructor(name, value = undefined) {
        super('lt', name, value);
    }
}
export class FilterLessOrEqualThan extends ComparisonFilter {
    constructor(name, value = undefined) {
        super('lte', name, value);
    }
}
export class FilterEqual extends ComparisonFilter {
    constructor(name, value = undefined) {
        super('eq', name, value);
    }
}
export class FilterGreaterThan extends ComparisonFilter {
    constructor(name, value = undefined) {
        super('gt', name, value);
    }
}
export class FilterGreaterOrEqualThan extends ComparisonFilter {
    constructor(name, value = undefined) {
        super('gte', name, value);
    }
}
